import { createQuery } from '@tanstack/svelte-query';
import { fetchProjectFiles } from '$lib/api/project_files';
import { resolveScope, getProjectScope, type ScopeFn } from './scope';

// unitScope, when given and non-nullish, scopes the query to a single unit's
// files (unit_id = that unit); otherwise it lists all project files.
// roomScope optionally narrows a unit to one room.
export const projectFilesQuery = (
	scope: ScopeFn = getProjectScope(),
	unitScope?: () => number | undefined,
	roomScope?: () => number | undefined
) =>
	createQuery<unknown[]>(() => {
		const projectId = resolveScope(scope);
		const unitId = unitScope?.();
		const roomId = roomScope?.();
		return {
			queryKey: ['project_files', { projectId, unitId, roomId }],
			queryFn: () => fetchProjectFiles(projectId, unitId, roomId),
			enabled: projectId > 0
		};
	});
